import { useQuery } from 'react-query';
import subscriptionApi from '../utils/api/subscription';

export function useSubscription() {
  return useQuery('subscriptions', () => subscriptionApi.show(), {
    refetchOnWindowFocus: false,
    keepPreviousData: false,
  });
}

export function useSubscriptionTenant() {
  return useQuery('subscriptionsTenant', () => subscriptionApi.showForTenant(), {
    refetchOnWindowFocus: false,
    keepPreviousData: false,
  });
}